import * as Ajax from './Ajax';
export { Ajax };
